import React from 'react';
import definicoescliente from '../../definicoes-cliente.json';

const textData = {
    titulo: 'PROTEÇÃO PARA VEÍCULOS DE ATÉ 400 MIL',
    descricao: 'Confiança é a base do nosso compromisso com o associado. Nosso propósito é oferecer tranquilidade para quem usa seu veículo, para lazer ou trabalho. Seja carro, moto ou caminhão nós temos a melhor proteção para garantir sua satisfação quando precisar usar algum benefício.',
    textoBotao: 'Saiba mais',
    imagemSrc: '/images/imagem-m4.jpg',
}

const ImagemTexto: React.FC = () => {

  return (
    <section id="imagem" className="flex flex-col md:flex-row px-6 items-center bg-theme-primary py-12 justify-between w-full lg:px-14">

      {/* Imagem */}
      <div className="w-full md:w-1/2 flex justify-center">
        <img 
          src={definicoescliente?.ImagemTexto?.Imagem || textData.imagemSrc} 
          className="w-full h-auto max-h-[400px] object-contain"
          alt="Descrição da imagem"/>
      </div>

      {/* Texto */}
      <div className="w-full md:w-1/2 md:p-12 text-center md:text-start mt-6 md:mt-0">
        <h2 className="text-textotitulo text-theme-light-primary font-bold mb-6">
          {definicoescliente?.ImagemTexto?.Titulo || textData.titulo}
        </h2>
        <p className="text-theme-light-primary text-textopadrao mb-8">
          {definicoescliente?.ImagemTexto?.Descricao || textData.descricao}
        </p>
        <button className="uppercase text-textopadrao bg-theme-secondary px-6 py-2 text-theme-light-secondary rounded shadow-md hover:filter hover:brightness-90 border-2 border-transparent hover:brightness-90 cursor-pointer transition duration-200">
          <a href={definicoescliente.ImagemTexto.LinkBotao || textData.textoBotao} target="_blank" rel="noopener noreferrer">
            {definicoescliente.ImagemTexto.NomeBotao || textData.textoBotao}
          </a>
        </button>
      </div>
    </section>
  );
};

export default ImagemTexto;
